module.exports = require("ng-simple-slideshow");